import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { TherapeuticIndicationApi } from '../../../apis/TherapeuticIndicationApi/TherapeuticIndicationApi';
import { IUpdateResourceUrlPayload } from '../TherapeuticIndication';

export function useUpdateTherapeuticIndicationResourceUrl() {
    const queryClient = useQueryClient();

    return useMutation<boolean, AppMedError, { id: number; data: IUpdateResourceUrlPayload }>({
        mutationFn: ({ id, data }) => TherapeuticIndicationApi.updateResourceUrl(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.therapeuticIndication] });
        },
    });
}
